/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
export const ListPelletProducts = [
    {
        name: 'Pelletizadora',
        id: 1,
        products: [
            {
                id: 1,
                name: 'Feller Teeth',
                img: require('../../assets/images/pellet/dente.png').default,
            },
            {
                id: 2,
                name: 'Matrizes',
                img: require('../../assets/images/pellet/matriz.png').default,
            },
            {
                id: 3,
                name: 'Eixo Principal',
                img: require('../../assets/images/pellet/eixo.png').default,
            },
            {
                id: 4,
                name: 'Eixo Oco',
                img: require('../../assets/images/pellet/eixoOco.png').default,
            },
            {
                id: 5,
                name: 'Flange de Vedação',
                img: require('../../assets/images/pellet/flange.png').default,
            },
            {
                id: 6,
                name: 'Engrenagem',
                img: require('../../assets/images/pellet/engrenagem.png')
                    .default,
            },
            {
                id: 7,
                name: 'Eixo Pinhão',
                img: require('../../assets/images/pellet/pinhao.png').default,
            },
        ],
    },
];
